export default __webpack_public_path__ + "static/media/settingIcon.7b8ed83f.svg";